import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-579f5740")

_pushScopeId("data-v-579f5740")
const _hoisted_1 = { class: "admin-maintenance" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_AdminForm = _resolveComponent("AdminForm")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_AdminForm, {
      bigTitle: "メンテナンス情報：",
      header1: "現在の設定値：",
      header2: "設定値の変更：",
      info: "※メンテナンス情報を削除する場合は、空欄にして適用を押してください。",
      referenceText: _ctx.currentManageContent,
      inputText: _ctx.editManageContent,
      "onUpdate:inputText": _cache[1] || (_cache[1] = ($event: any) => (_ctx.editManageContent = $event)),
      onUpdate: _ctx.update
    }, null, 8, ["referenceText", "inputText", "onUpdate"])
  ]))
})